/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import { RadioButton } from 'grommet';

import { Text } from '@blend/alchemy';

const RadioBox = styled(Box)<{ checked: boolean }>`
  align-items: flex-start;
  background-color: transparent;
  border: 1px solid;
  border-color: ${props => (props.checked ? props.theme.global.colors.sky : props.theme.global.colors.cloud70)};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.global.edgeSize.small};
  text-align: left;
  width: 100%;

  &:hover {
    border-color: ${props => props.theme.global.colors.sky};
  }
`;

const SecondaryLabelBox = styled(Box)`
  margin-top: ${props => props.theme.global.edgeSize.xsmall};
`;

interface BoxRadioButtonProps {
  checked: boolean;
  name: string;
  primaryLabel: string;
  id: string;
  secondaryLabel?: string;
  value: string | number;
  checkedChildren?: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}
export const BoxRadioButton: React.FC<BoxRadioButtonProps> = ({
  checked,
  children,
  name,
  onClick,
  primaryLabel,
  secondaryLabel,
  value,
  id,
}) => (
  <Field name={name} type="radio" value={value}>
    {props => (
      <RadioBox
        checked={!!checked}
        id={id}
        margin={{ top: 'small' }}
        onClick={e => {
          // This funny business is required since an onChange function is being
          // used inside of a button which only allows onClick functions.
          props.input.onChange({ target: { value, type: 'radio' } });
          onClick(e);
          e.preventDefault();
        }}
        tabIndex={0}
      >
        <RadioButton
          checked={checked}
          label={primaryLabel}
          name={props.input.name}
          onChange={props.input.onChange}
          tabIndex={-1}
          value={props.input.value}
        />
        {!!secondaryLabel && (
          <SecondaryLabelBox>
            <Text.Info>{secondaryLabel}</Text.Info>
          </SecondaryLabelBox>
        )}
        {checked && children}
      </RadioBox>
    )}
  </Field>
);
